import type { AnalyticsRepository } from "@/domain/repositories/analytics.repository";
import type { LeadRepository } from "@/domain/repositories/lead.repository";
import type { VehicleRepository } from "@/domain/repositories/vehicle.repository";
import { env } from "@/infrastructure/config/env";
import { HttpClient } from "@/infrastructure/http/http-client";
import { HttpAnalyticsRepository } from "@/infrastructure/repositories/http/http-analytics.repository";
import { HttpLeadRepository } from "@/infrastructure/repositories/http/http-lead.repository";
import { HttpVehicleRepository } from "@/infrastructure/repositories/http/http-vehicle.repository";
import { MockAnalyticsRepository } from "@/infrastructure/repositories/mock/mock-analytics.repository";
import { MockLeadRepository } from "@/infrastructure/repositories/mock/mock-lead.repository";
import { MockVehicleRepository } from "@/infrastructure/repositories/mock/mock-vehicle.repository";

export type Repositories = {
  vehicles: VehicleRepository;
  leads: LeadRepository;
  analytics: AnalyticsRepository;
};

export function createRepositories(): Repositories {
  if (env.isApi) {
    const client = new HttpClient(env.apiBaseUrl);
    return {
      vehicles: new HttpVehicleRepository(client),
      leads: new HttpLeadRepository(client),
      analytics: new HttpAnalyticsRepository(client),
    };
  }

  return {
    vehicles: new MockVehicleRepository(),
    leads: new MockLeadRepository(),
    analytics: new MockAnalyticsRepository(),
  };
}

export const repositories = createRepositories();
